import React from 'react';
import style from './jsReturnType.scss';
import { TypeRectangle } from '../../../../../PageElements/TypeRectangle';
import { ReactMarkdownDisplay } from '../../../../../PageElements/ReactMarkdownDisplay';
import { Heading, APPEARANCES } from '../../../../../PageElements/Heading';
import { isLegacyType } from '../../../../typeParser';

export const JSReturnType = ({ ret, prefix, name, JSLayoutType }) => {
  const isReturnTypeVoid = () => {
    const isSingleTypeVoid = (singleType) => {
      return singleType === 'void';
    };
    return isLegacyType(ret.type)
      ? isSingleTypeVoid(ret.type)
      : ret.type.length === 1 && isSingleTypeVoid(ret.type[0].nativeType);
  };

  const doc = isReturnTypeVoid()
    ? 'This function does not return anything.'
    : ret.doc;

  return (
    <div data-hook="js-return-type">
      <Heading
        className={doc ? style.title : ''}
        appearance={APPEARANCES.H3}
        dataHook="js-return-type-heading"
      >
        Returns
      </Heading>
      {doc && (
        <div className={style.doc} data-hook="js-return-type-description">
          <ReactMarkdownDisplay markdown={doc} prefix={prefix} mdName={name} />
        </div>
      )}
      <TypeRectangle
        title="Return Type:"
        type={ret.type}
        displayName={ret.displayName}
        prefix={prefix}
        pageName={name}
        isResponse={true}
        JSLayoutType={JSLayoutType}
      />
    </div>
  );
};
